import React, { Component } from 'react';
import InputMask from 'react-input-mask';

class InputGroupComponent extends Component {
  render() {
    return (
      <div className="form-group">
        {
          this.props.mask ? 
          <InputMask 
            className={(this.props.submitted && !this.props.property) || (this.props.submitted && this.props.invalid) ? 'form-control form-control-error' : 'form-control'} 
            mask={this.props.mask}
            name={this.props.name} 
            id={this.props.name} 
            value={this.props.property} 
            onChange={this.props.hasChanged}
            readOnly={this.props.readOnly}
            maskChar=''>
          </InputMask>
          :
          <input
            type={this.props.type}
            name={this.props.name}
            id={this.props.name}
            className={(this.props.submitted && !this.props.property) || (this.props.submitted && this.props.invalid) ? 'form-control form-control-error' : 'form-control'}
            autoComplete="off"
            onChange={this.props.hasChanged}
            defaultValue={this.props.property}
            readOnly={this.props.readOnly}
          />
        }
        <label htmlFor={this.props.name}>{this.props.label}</label>
        {this.props.submitted && !this.props.property && <div className="input-error">{this.props.onError}</div>}
        {this.props.submitted && this.props.invalid && this.props.property && <div className="input-error">{this.props.onInvalid}</div>}
      </div>
    )
  }
}

export { InputGroupComponent as Input }